var map = {
	"./1.png": 216,
	"./10.png": 217,
	"./11.png": 218,
	"./12.png": 219,
	"./2.png": 220,
	"./3.png": 221,
	"./4.png": 222,
	"./5.png": 223,
	"./6.png": 224,
	"./7.png": 225,
	"./8.png": 226,
	"./9.png": 227,
	"./bg.png": 228,
	"./btn.png": 126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 123;